import { getCSSUnitValue, getCurrentViewportSize } from '@scp/ui-shared/theme/utils';
export var getAbsolutePosCoordinates = function getAbsolutePosCoordinates(position, isVertical) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    x: 0,
    y: 0
  };
  var x = getCSSUnitValue(offset.x);
  var y = getCSSUnitValue(offset.y);

  if (isVertical) {
    switch (position) {
      case 'top left':
        return [y, null, null, x];

      case 'top right':
        return [y, x, null, null];

      case 'bottom left':
        return [null, null, y, x];

      case 'bottom right':
        return [null, x, y, null];

      case 'top center':
        return [x, null, null, y];

      case 'bottom center':
        return [null, null, x, y];

      default:
        return [0, 0, 0, 0];
    }
  }

  switch (position) {
    case 'top left':
      return [x, null, null, y];

    case 'top right':
      return [x, y, null, null];

    case 'bottom left':
      return [null, null, x, y];

    case 'bottom right':
      return [null, y, x, null];

    case 'top center':
      return [x, null, null, y];

    case 'bottom center':
      return [null, null, x, y];

    default:
      return [0, 0, 0, 0];
  }
};
export var getPopoverPosCoordinates = function getPopoverPosCoordinates(_ref) {
  var position = _ref.position,
      isVertical = _ref.isVertical,
      anchorCoordinates = _ref.anchorCoordinates,
      triangleWidth = _ref.triangleWidth,
      triangleHeight = _ref.triangleHeight,
      width = _ref.width;
  var fullWidth = width === '100%';

  var _getPosition = getPosition(anchorCoordinates, hasTriangle(triangleWidth, triangleHeight), isVertical, fullWidth),
      top = _getPosition.top,
      right = _getPosition.right,
      bottom = _getPosition.bottom,
      left = _getPosition.left;

  var centerLeft = function centerLeft() {
    var leftValue = typeof left === 'string' ? parseInt(left) : left;
    return typeof width === 'number' ? "".concat(leftValue + anchorCoordinates.width / 2 - width / 2, "px") : left;
  };

  switch (position) {
    case 'top left':
      return [top, null, null, left];

    case 'top right':
      return [top, right, null, null];

    case 'bottom left':
      return [null, null, bottom, left];

    case 'bottom right':
      return [null, right, bottom, null];

    case 'top center':
      return [top, null, null, centerLeft()];

    case 'bottom center':
      return [null, null, bottom, centerLeft()];

    default:
      return [0, 0, 0, 0];
  }
};
export var getPosition = function getPosition(anchorCoordinates, withTriangle, isVertical, fullWidth) {
  var viewportSize = getCurrentViewportSize();

  if (isVertical && withTriangle) {
    return {
      top: getCSSUnitValue(anchorCoordinates.top),
      right: getCSSUnitValue(viewportSize.width - anchorCoordinates.left),
      bottom: getCSSUnitValue(viewportSize.height - anchorCoordinates.bottom),
      left: getCSSUnitValue(anchorCoordinates.right)
    };
  }

  if (!withTriangle) {
    return {
      top: getCSSUnitValue(anchorCoordinates.top),
      right: getCSSUnitValue(viewportSize.width - anchorCoordinates.right),
      bottom: getCSSUnitValue(viewportSize.height - anchorCoordinates.bottom),
      left: getCSSUnitValue(anchorCoordinates.left)
    };
  }

  return {
    top: getCSSUnitValue(anchorCoordinates.top + anchorCoordinates.height),
    right: fullWidth ? 0 : getCSSUnitValue(viewportSize.width - anchorCoordinates.right),
    bottom: getCSSUnitValue(viewportSize.height - anchorCoordinates.top),
    left: fullWidth ? 0 : getCSSUnitValue(anchorCoordinates.left)
  };
};
export var getTriangleDirection = function getTriangleDirection(position, isVertical) {
  if (isVertical) {
    return ['top left', 'bottom left'].includes(position) ? 'left' : 'right';
  }

  return ['top left', 'top right', 'top center'].includes(position) ? 'top' : 'bottom';
};
export var hasTriangle = function hasTriangle(width, height) {
  return !!(width && height);
};